var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5V20M15 7.5V5C15 4.44772 14.5523 4 14 4H10C9.44772 4 9 4.44772 9 5V10.5M15 7.5H20C20.5523 7.5 21 7.94772 21 8.5V19C21 19.5523 20.5523 20 20 20H15M15 20H9M9 10.5V20M9 10.5H3.99967C3.44738 10.5 3 10.9477 3 11.5V19C3 19.5523 3.44772 20 4 20H9",
    stroke: "#4C596E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.bf35aa42df4a028961a1f97288b43806.svg";
export { ForwardRef as ReactComponent };